import { PHASES } from "const/phases.const";
// import parse from "html-react-parser";

export const home = [
  {
    type: "hero",
    data: {},
  },
  {
    type: "counter",
    phase: [PHASES.WAITING],
    data: {
      title: "Mint opens in"
    },
  },

  
  {
    type: "textBlock",
    phase: [PHASES.WAITING],
    data: {
      id: "textBlock-waiting",
      headline: "Check to see if you're on the allowlist",
      text: [
        "Signup for the mint allowlist is closed. You can check the results here.\nMint will start June 23rd, 17.00 UTC.",
      ],
      button: {
        label: "Check Allowlist",
        link: "https://www.premint.xyz/not-in-paris/verify/",
        external: true,
      },
    },
  },
  {
    type: "textBlock",
    phase: [PHASES.MINT],
    data: {
      id: "textBlock-waiting",
      headline: "Mint is open",
      text: [
        "You can mint your Not In Paris NFT now.\nCheck if you made it to the allowlist or waitlist <a href='https://www.premint.xyz/not-in-paris/verify' target='_blank'>here</a>.",
        "Allowlist can mint from June 23rd until June 24th, 17.00 UTC\nWaitlist can mint starting June 24th, 09.00 UTC\nReveal will be at June 25th, 17.00 UTC",
      ],
      button: {
        label: "Mint Here",
        link: "https://nft.highsnobiety.com/notinparis/mint",
        external: true,
      },
    },
  },
  {
    type: "textBlock",
    phase: [PHASES.POST, PHASES.AIRDROP],
    data: {
      id: "textBlock-waiting",
      headline: "Sold Out",
      text: [
        "Not In Paris NFTs are sold out. Check out Opensea to get yours from the secondary market.",
      ],
      button: {
        label: "Buy on OpenSea",
        link: "https://opensea.io/collection/not-in-paris",
      },
    },
  },
  {
    type: "textBlock",
    phase: [PHASES.AIRDROP],
    data: {
      id: "textBlock-nip-airdrop",
      overHeadline: "/assets/images/hl-airdrop.svg",
      headline: "Join the Not In Paris Exhibition",
      text: [
        "350 Not In Paris Spaces were airdropped to holders of the Not In Paris NFTs. This space allows you to exhibit your own NFTs in the Not in Paris Oncyber digital pop-up. If you weren’t eligible for the airdrop you can get one from the secondary market.",
      ],
      button: {
        label: "DISCOVER THE NFT",
        link: "https://opensea.io/assets/matic/0x6eba841f1201ffdde7ddc2ba995d3308f6c4aea0/4",
      },
      divider: true,
    },
  },
  {
    type: "poster",
    data: {
      image: {
        desktop: "/assets/images/poster-2.jpg",
        mobile: "/assets/images/poster-2.jpg",
      },
    },
  },
  {
    type: "textBlock",
    data: {
      id: "textBlock-nip-paris",
      overHeadline: "/assets/images/hl-about.svg",
      headline: "NOT IN PARIS",
      text: [
        "Curated by Highsnobiety and presented during Paris Men’s Fashion Week, Not In Paris is our digital exhibition celebrating creativity in the age of remote interactions.",
        "Now in its fourth edition, Not In Paris includes exclusive product, content and experiences in partnership with the fashion world’s best minds. Previous exhibitions included collaborations with Gucci, Rick Owens, MSCHF, Bottega Veneta, and RTFKT. Stay tuned for this year’s lineup.",
      ],
    },
  },
  {
    type: "textBlock",
    phase: [PHASES.PREMINT],
    data: {
      id: "textBlock-allowlist",
      headline: "How to apply to the Allowlist",
      text: [
        "To give everyone the same chance to participate in the upcoming Not In Paris mint, we have set up registration on Premint.xyz.",
        "We will randomly select the 320 winning spots from among all the entrants. If you make it to the allowlist, you have 16 hours to mint. If not everyone mints who is on the allowlist, we will have a separate waitlist that will then have a chance to mint the remaining NFTs on a first come, first serve basis. If we are not sold out after 20 hours, we will open the public sale for 4 hours.",
        "Registration for the Allowlist ends on June 22nd at 17.00 UTC.\nWe will select the wallets for the allowlist and waitlist on June 22nd at 18.00 UTC. From that time on, you will also be able to check if you made it to the allowlist or the waitlist.",
        "Registration at Premint.xyz ends June 22nd, 17.00 UTC\nMint will start June 23rd, 17.00 UTC",
      ],
      button: {
        label: "APPLY FOR ALLOWLIST",
        link: "https://www.premint.xyz/not-in-paris/",
        external: true,
      },
    },
  },
  {
    type: "poster",
    data: {
      image: {
        desktop: "/assets/images/poster-1.jpg",
        mobile: "/assets/images/poster-1.jpg",
      },
    },
  },
  {
    type: "textBlock",
    data: {
      id: "textBlock-nip-nft",
      overHeadline: "/assets/images/hl-the.svg",
      headline: "Not In Paris NFT",
      text: [
        "Not In Paris has democratized fashion week. Instead of invite-only shows behind closed doors, we bring the experience to where creativity really flourishes — the internet. Since Not In Paris is so rooted in the digital, this year, we had to create our own series of NFTs to commemorate the project.",
        "We’re releasing six NFT designs, all with different rarities resulting in a total of 350. One of each design is reserved for our future Highsnobiety NFT museum and 24 are reserved for “friends and family”. 320 will be publicly available, all through a raffle on Premint.xyz.",
      ],
    },
  },
  {
    type: "gallery",
    data: {
      id: "gallery",
      link: {
        allowlist: "https://www.premint.xyz/not-in-paris/",
        mint: "https://nft.highsnobiety.com/notinparis/mint",
      },
      items: [
        {
          label: "NOT IN PARIS NFT #1",
          title: "Tower",
          number: "7/350",
          video:
            "https://player.vimeo.com/progressive_redirect/playback/721164905/rendition/720p/file.mp4?loc=external&signature=ff8415cd930d253c7f1867e08d62e733803dd6d03221af5e5b63ce270bb8bb0b",
          poster: "/assets/nft/tower.jpg",
        },
        {
          label: "NOT IN PARIS NFT #2",
          title: "Macaron",
          number: "18/350",
          video:
            "https://player.vimeo.com/progressive_redirect/playback/721165022/rendition/720p/file.mp4?loc=external&signature=e1b1da1e0cba79a7d2ab53534dfd80cb6f0a1230f9c6578006129424017465c7",
          poster: "/assets/nft/macaron.jpg",
        },
        {
          label: "NOT IN PARIS NFT #3",
          title: "Spliff",
          number: "35/350",
          video:
            "https://player.vimeo.com/progressive_redirect/playback/721164958/rendition/720p/file.mp4?loc=external&signature=322d550490fd3aebe3fbd3c788250f1b33e46ad6c1625a4e83ddcf139efeb2d6",
          poster: "/assets/nft/spliff.jpg",
        },
        {
          label: "NOT IN PARIS NFT #4",
          title: "Cheese",
          number: "53/350",
          video:
            "https://player.vimeo.com/progressive_redirect/playback/721165173/rendition/720p/file.mp4?loc=external&signature=337edb4c007398ccf23c87b39e7843b74a45599a794957236309c7ede9500492",
          poster: "/assets/nft/cheese.jpg",
        },
        {
          label: "NOT IN PARIS NFT #5",
          title: "Chair",
          number: "87/350",
          video:
            "https://player.vimeo.com/progressive_redirect/playback/721165236/rendition/720p/file.mp4?loc=external&signature=b3ea7eee719f125e4a6b43ff14b81b76952aae04258fce15fc8793939933da11",
          poster: "/assets/nft/chair.jpg",
        },
        {
          label: "NOT IN PARIS NFT #6",
          title: "Cup",
          number: "150/350",
          video:
            "https://player.vimeo.com/progressive_redirect/playback/721165091/rendition/720p/file.mp4?loc=external&signature=1eaba4d8c1cb866c62ed06894d3fb36474809e50c34dcfcd4d6eb500a255a319",
          poster: "/assets/nft/cup.jpg",
        },
      ],
    },
  },
  {
    type: "textBlock",
    data: {
      id: "textBlock-nip-art",
      overHeadline: "/assets/images/hl-the.svg",
      headline: "Visuals",
      text: [
        "Not In Paris has always played with Parisian stereotypes, drawing equal inspiration from tourist aesthetics and the city’s surrealist past. For our series of NFTs, we played around with some of Paris’ most recognisable icons — a macaron, a wheel of brie, a spliff, the Eiffel Tower, and a Café de Flore coffee cup — and gave them the Highsnobiety treatment.",
      ],
    },
  },
  {
    type: "videoBlock",
    data: {
      id: "video-nip-cyber",
      poster: "/assets/images/video-space-preview.jpg",
      video: {
        desktop:
          "https://player.vimeo.com/progressive_redirect/playback/722144451/rendition/1080p/file.mp4?loc=external&signature=50369cdad077c72a61ea5e19a58616e7955e05fa574dcc9a77edc1f36b64f45b",
        mobile:
          "https://player.vimeo.com/progressive_redirect/playback/722144451/rendition/540p/file.mp4?loc=external&signature=5e319a02ff4c02897971ba0fecf427533daa467a42f21b27332d3674796e9811",
      },
      link: "https://oncyber.io/not-in-paris",
    },
  },
  {
    type: "textBlock",
    data: {
      id: "textBlock-nip-cyber",
      script: "visit",
      overHeadline: "/assets/images/hl-visit.svg",
      headline: "Not in Paris Oncyber Space",
      text: [
        "If you can’t make it to our physical pop-up store in Paris, we got you. In collaboration with oncyber we’ve created a virtual version of our Not In Paris space. A digital representation of our store located at 35 Rue des Francs Bourgeois. This virtual space comes complete with all of our six NFTs and has some virtual interior you cannot build in real life.",
      ],
      button: {
        label: "VISIT THE GALLERY",
        link: "https://oncyber.io/not-in-paris",
      },
    },
  },
  {
    type: "accordion",
    data: {
      id: "accordion",
      headline: "Frequently Asked Questions",
      items: [
        {
          question: "What’s an NFT?",
          answer: [
            "NFT stands for non-fungible token.",
            "If you’re not familiar with the term ‘non-fungible’, it basically means that the item can only be bought or sold in its entirety; such as art, cars, and other collectibles. Each token represents rights/utility to a unique digital asset or collectible. ",
            "The rules for how an NFT operates are written in what’s called a ‘smart contract’. This automates processes like residual payments/royalties.",
            "The Not In Paris NFTs are minted on the Ethereum blockchain.",
          ],
        },
        {
          question: "How Can I Buy a Highsnobiety NFT?",
          answer: [
            "To purchase a Not In Paris NFT, you’ll first need to purchase Ethereum (ETH)- the blockchain Highsnobiety has chosen to mint our NFTs on.",
            "",
            "If you don’t have an NFT wallet, here are a few great options: <br />- Metamask (sign-up: <a href='https://metamask.io/' target='_blank'>https://metamask.io/</a>) <br />- Coinbase (sign-up: <a href='https://www.coinbase.com/wallet' target='_blank'>https://www.coinbase.com/wallet</a>) <br />- WalletConnect (sign-up: <a href='https://cloud.walletconnect.com/sign-up' target='_blank'>https://cloud.walletconnect.com/sign-up</a>) ",

            "Once you’ve signed up and purchased Ethereum, use the ‘Mint’ button to connect your wallet and mint a token.",
            "You need to be on the allowlist to have a chance at minting a Not In Paris NFT. Applications for the allowlist can be found above under ‘Apply For Mint’.",
            "We’ll be using Premint.xyz for the allowlist. Registration ends June 22nd at 17:00 UTC. We’ll be announcing the results an hour later at 18:00 UTC.",
          ],
        },
        {
          question: "Why Buy a Not In Paris NFT?",
          answer: [
            "The Not In Paris NFT is our first entry into the metaverse. As a digital collectible, we’re making this drop a scarce collection of 350 NFTs. Later on, Highsnobiety will be unveiling other extras that are included with purchase",
            "The NFTs will be revealed post-mint on June 25th at 17:00 UTC",
          ],
        },
        {
          question: "How Does Allowlisting Work? Is There a Raffle?",
          answer: [
            "Allowlisting is the sign-up that enables you to enter our raffle for minting a token.",
            "Signing-up for the allowlist does not automatically guarantee a chance at minting, but rather a chance to enter our raffle for minting.",
            "To sign-up for the allowlist, click the ‘Apply For Mint’ button above. From there, you’ll be asked to connect your wallet and provide your email address. We’ll be notifying participants of their application status on June 22nd at 18:00 UTC.",
            "We’ll additionally be having a waitlist, who can start minting after June 24th.",
            "Remaining NFTs can be minted between 13.00 UTC and 17.00 UTC on June 24th.",
          ],
        },
        {
          question: "What’s Minting?",
          answer: [
            "Minting is the process of putting your token on the blockchain. For the Not In Paris NFTs, we’ll be using ERC-721 tokens, which will be minted on the Ethereum blockchain.",
            "The Minting Process:",
            " - Minting will start June 23rd, 17.00 UTC. <br /> - Allowlist members can mint from June 23rd until June 24th, 17.00 UTC.<br /> - Waitlist members will be able to mint starting June 24th, 09.00 UTC. <br /> - Remaining NFTs can be minted between 13.00 UTC and 17.00 UTC on June 24th.",
          ],
        },
        {
          question: "What’s Gas? Why Do I Need to Pay for It?",
          answer: [
            "Gas is the cost of successfully processing a transaction on the Ethereum Network. These fees help The Ethereum Foundation keep Ethereum (and all the NFTs built on top of it) running smoothly.",
            "Depending on the volume of transactions at a given time, the cost of gas can vary.",
          ],
        },
        {
          question: "How Can I Keep My Not In Paris NFT Safe?",
          answer: [
            "There are a few key considerations you should follow to keep your NFTs safe:",
            "1. When you sign up for a wallet, you'll be given a seed phrase and security key. Write these down on paper and store them in a safe place, as they'll be incredibly difficult to recover later. These are cryptographic security measures to protect your wallet. Don't share them with anyone. <br/> 2. Be wary of phishing emails, fake giveaways/airdrops, and other common hacker techniques. <br/> 3. Consider buying in a physical wallet: Ledger is considered the standard, which helps protects your NFTs away from the connected internet altogether.",
            "We recommend checking out the #security channel on our Discord (public link) for more helpful tips.",
          ],
        },
        {
          question: "Can I Resell My Not In Paris NFT?",
          answer: [
            "Not In Paris NFTs are available for resale on <a href='https://opensea.io/' target='_blank'>OpenSea</a> or <a href='https://looksrare.org/' target='_blank'>LooksRare</a> .",
          ],
        },
        {
          question: "Does Highsnobiety Take Royalties from Reselling The NFT?",
          answer: [
            "Yes, for the Not In Paris drop, Highsnobiety will be taking 7.5 percent of all secondary sales.",
          ],
        },
        {
          question: "How Do Refunds Work with Highsnobiety NFTs?",
          answer: [
            "All NFT sales issued by Highsnobiety are final.",
            "Although Highsnobiety does not issue refunds for NFT purchases, token holders are free to resell their NFTs on secondary markets like OpenSea.",
          ],
        },
        {
          question: "Aren’t NFTs Bad For The Environment?",
          answer: [
            "Currently, Ethereum processes transactions using the Proof-Of-Work process, which requires a significant amount of energy to use. For the past few years, The Ethereum Foundation has been working on merging their entire infrastructure to a Proof-Of-Stake blockchain, which is happening in the late Summer of 2022. This will reduce Ethereum’s energy consumption by an estimated 99 percent. ",
            "Until the change over to Proof-Of-Stake happens, Highsnobiety is committed to offsetting the emissions our NFTs produce via Aerial: <a href='https://aerial.is/nft' target='_blank'>https://aerial.is/nft</a>",
          ],
        },
      ],
    },
  },
];

export const stageConfig = {
  items: [
    {
      assetIndex: 0,
      scallar: 0.1,
      speed: 0.85,
      offsetRad: Math.PI * 0.4,
      yOffset: 0.8,
    },
    {
      assetIndex: 1,
      scallar: 7,
      speed: 1,
      offsetRad: Math.PI * 1.2,
      yOffset: 1,
    },
    {
      assetIndex: 2,
      scallar: 0.01,
      speed: -0.9,
      offsetRad: Math.PI * 0.4,
      yOffset: 1,
    },
    {
      assetIndex: 3,
      scallar: 0.01,
      speed: 1.1,
      offsetRad: Math.PI * 1.6,
      yOffset: 1.3,
    },
    {
      assetIndex: 4,
      scallar: 1,
      speed: -1,
      offsetRad: Math.PI * 0.9,
      yOffset: 0.8,
    },
    {
      assetIndex: 5,
      scallar: 0.001,
      speed: 1.2,
      offsetRad: Math.PI * 1.8,
      yOffset: 1,
    },
    // {
    //   assetIndex: 7,
    //   scallar: 1,
    //   speed: 0.8,
    //   offsetRad: Math.PI * 1.8,
    // },
    // {
    //   assetIndex: 6,
    //   scallar: 0.01,
    //   speed: -0.5,
    //   offsetRad: Math.PI * 0.5,
    // },
  ],
};
